import { createContext, useContext, ReactNode } from 'react'
import { useCart } from '../hooks/useCart'
import type { Cart } from '../services/api'

interface CartContextValue {
  cart: Cart | null
  loading: boolean
  error: string | null
  addToCart: (productId: string, quantity?: number) => Promise<void>
  updateQuantity: (itemId: string, quantity: number) => Promise<void>
  removeItem: (itemId: string) => Promise<void>
  clearCart: () => Promise<void>
  refreshCart: () => Promise<void>
  getItemQuantity: (productId: string) => number
  getTotalItems: () => number
  isItemInCart: (productId: string) => boolean
}

const CartContext = createContext<CartContextValue | undefined>(undefined)

export function CartProvider({ children }: { children: ReactNode }) {
  const cart = useCart()

  return (
    <CartContext.Provider value={cart}>
      {children}
    </CartContext.Provider>
  )
}

export function useCartContext() {
  const context = useContext(CartContext)
  if (context === undefined) {
    throw new Error('useCartContext must be used within a CartProvider')
  }
  return context
}
